// @ts-nocheck
import { Dialog, Transition } from "@headlessui/react";
import React, { Fragment, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import Primarybtn from "../../../common/buttons/Primarybtn";
import TextInput from "../../../common/inputElements/TextInput";
import FileInput from "../../../common/inputElements/FileInput";
import { UPDATE_EVENT } from "../../../redux/constants/eventConstants";
import { useDispatch } from "react-redux";
import axios from "axios";
import throttle from "../../../utils/throttle";
import { useMatch } from "react-router-dom";
import TextArea from "../../../common/inputElements/TextArea";
import { showToast } from "../../../redux/actions/toastActions";

export default function AddSpeaker({
  open,
  setOpen,
  event,
  speakers,
  setSpeakers,
  isEdit,
  setIsEdit,
  singleSpeaker,
  setSingleSpeaker,
}) {
  const [profilePicture, setProfilePicture] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [characterCount, setCharacterCount] = useState("");
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: {
      ...singleSpeaker,
    },
    mode: "onChange",
  });
  useEffect(() => {
    if (!isEdit) {
      reset({
        firstName: "",
        lastName: "",
        jobTitle: "",
        organization: "",
        email: "",
        bio: "",
        linkedinUrl: "",
        profilePicture: "",
      });
      setCharacterCount("");
    } else if (singleSpeaker?.firstName) {
      setProfilePicture(singleSpeaker.profilePicture);
      reset(singleSpeaker);
      setCharacterCount(singleSpeaker?.bio.slice(0, 500));
    }
    if (!open) {
      setProfilePicture("");
    }
  }, [singleSpeaker?.firstName, isEdit, open]);

  // useEffect(() => {
  //   setProfilePicture("");
  // }, [open]);

  const dispatch = useDispatch();
  const eventsId = useMatch("/events/:eventId");
  const onChange = (e) => {
    const formData = new FormData();
    formData.append("file", e.target.files[0]);

    axios
      .post(
        `${process.env.REACT_APP_SERVER_URL_LEADS}/user/upload_picture`,
        formData,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
          },
        }
      )
      .then(function (response) {
        console.log(response);
        setProfilePicture(response.data.url);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const onSubmit = async (data) => {
    setIsSubmitting(true);
    setProfilePicture(singleSpeaker.profilePicture);
    if (Object.values(data).length <= 0) {
      dispatch(
        showToast({
          message: "Please fill all the details",
          category: "danger",
        })
      );
    } else {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_SERVER_URL_LEADS}/event/${
            eventsId.params.eventId
          }/${isEdit ? "editSpeaker" : "registerSpeaker"}`,
          {
            method: isEdit ? "PATCH" : "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              userEmail: data.email,
              data: {
                userData: {
                  firstName: data.firstName,
                  lastName: data.lastName,
                  jobTitle: data.jobTitle,
                  organization: data.organization,
                  email: data.email.toLowerCase(),
                  linkedinUrl: data.linkedinUrl,
                  profilePicture: profilePicture,
                },
                eventSpecificData: {
                  eventId: eventsId.params.eventId,
                  eventSpecificRole: "speaker",
                  bio: data.bio,
                },
              },
            }),
          }
        );

        const allSpeakers = await response.json();
        if (response.status !== 200) {
          dispatch(
            showToast({
              message: "Please add again!! some error occurred",
              category: "danger",
            })
          );
        }

        if (isEdit && response.status === 200) {
          dispatch(
            showToast({
              message: "Changes Saved Successfully",
              category: "success",
            })
          );
        } else if (!isEdit && response.status === 200) {
          dispatch(
            showToast({
              message: "Speaker Added Successfully",
              category: "success",
            })
          );
        }

        dispatch({
          type: UPDATE_EVENT,
          payload: {
            speakers: allSpeakers.message.speakers,
          },
        });

        setOpen(false);
        setIsEdit(false);
        setSingleSpeaker({
          firstName: "",
          lastName: "",
          jobTitle: "",
          organization: "",
          email: "",
          bio: "",
          linkedinUrl: "",
          profilePicture: "",
        });
        setIsSubmitting(false);
        reset();
      } catch (error) {
        console.log(error);
        setIsSubmitting(false);
      }
    }
  };

  return (
    <>
      <Transition.Root show={open} as={Fragment}>
        <Dialog as="div" className="relative z-40" onClose={setOpen}>
          <Transition.Child
            as={Fragment}
            enter="ease-in-out duration-500"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in-out duration-500"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="z-40 fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="z-40 fixed inset-0 overflow-hidden">
            <div className="absolute inset-0 overflow-hidden">
              <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10">
                <Transition.Child
                  as={Fragment}
                  enter="transform transition ease-in-out duration-500 sm:duration-700"
                  enterFrom="translate-x-full"
                  enterTo="translate-x-0"
                  leave="transform transition ease-in-out duration-500 sm:duration-700"
                  leaveFrom="translate-x-0"
                  leaveTo="translate-x-full"
                >
                  <Dialog.Panel className="pointer-events-auto relative w-screen max-w-md">
                    <Transition.Child
                      as={Fragment}
                      enter="ease-in-out duration-500"
                      enterFrom="opacity-0"
                      enterTo="opacity-100"
                      leave="ease-in-out duration-500"
                      leaveFrom="opacity-100"
                      leaveTo="opacity-0"
                    >
                      <div className="absolute top-0 left-[45px] md:left-0 -ml-8 flex pt-4 pr-2 sm:-ml-10 sm:pr-4">
                        <button
                          type="button"
                          className="rounded-md hidden outline-none md:block text-gray-300"
                          onClick={() => setOpen(false)}
                        >
                          <span className="sr-only">Close panel</span>X
                          {/* <XMarkIcon className="h-6 w-6" aria-hidden="true" /> */}
                        </button>
                        <button
                          className="md:hidden flex items-center"
                          onClick={() => setOpen(false)}
                        >
                          <i className="fa fa-angle-left text-[24px]"></i>
                          <span className="text-[17px] pt-0.5">Back</span>
                        </button>
                      </div>
                    </Transition.Child>
                    <div className="flex h-full flex-col overflow-y-scroll bg-white py-3 shadow-xl">
                      <div className="px-4 sm:px-6 fixed z-20 bg-white w-[100%] top-0">
                        <Dialog.Title className="text-[22px] pt-5 pb-4 font-[600] text-gray-900 ">
                          {!isEdit ? "Add a new speaker" : "Edit speaker"}
                        </Dialog.Title>
                      </div>
                      <div className="relative mt-[75px] flex-1 px-4 sm:px-6 mb-[50px]">
                        <form
                          onSubmit={handleSubmit((data) =>
                            throttle(() => onSubmit(data), 5000)
                          )}
                          className="flex flex-col"
                        >
                          <TextInput
                            register={register}
                            type="url"
                            id={"linkedinUrl"}
                            placeholder="LinkedIn URL"
                            label="Linkedin URL"
                          />
                          {/* <div> */}
                          <TextInput
                            register={register}
                            disabled={isEdit ? true : false}
                            type="email"
                            id={"email"}
                            placeholder="Email Address"
                            label="Email"
                            required
                            errors={errors}
                            pattern={
                              /^([a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?)$/i
                            }
                          />
                          {!isEdit && (
                            <span className="text-[12px] mt-[-22px] mb-[20px] font-[500] text-[#E74C3C]">
                              Invite mail will be sent to this email
                            </span>
                          )}

                          {/* </div> */}
                          {/* <TextInput
                            register={register}
                            type="email"
                            id={"email"}
                            placeholder="Email Address"
                            label="Email"
                          /> */}
                          <TextInput
                            register={register}
                            type="text"
                            required
                            id={"firstName"}
                            placeholder="First Name"
                            label="First Name"
                          />
                          <TextInput
                            register={register}
                            type="text"
                            required
                            id={"lastName"}
                            placeholder="Last Name"
                            label="Last Name"
                          />
                          <TextInput
                            register={register}
                            type="text"
                            required
                            id={"organization"}
                            placeholder="Company/ Organization Name"
                            label="Company/ Organization Name"
                          />
                          <TextInput
                            register={register}
                            type="text"
                            required
                            id={"jobTitle"}
                            placeholder="Designation"
                            label="Designation"
                          />
                          <FileInput
                            profilePicture={profilePicture}
                            setProfilePicture={setProfilePicture}
                            label="Profile Picture (Recommended size - 500 X 500 pixels)"
                            mb="1"
                          />
                          {/* <input
                            type="file"
                            {...register("profilePicture", {
                              onChange: onChange,
                            })}
                            className="bg-[#f4f6f9] mb-[45px] rounded-[8px] text-[12px]"
                          /> */}
                          {/* <TextInput
                            register={register}
                            type="text"
                            id={"bio"}
                            placeholder="Bio"
                            label="Bio"
                          /> */}

                          <TextArea
                            register={register}
                            type="text"
                            id={"bio"}
                            placeholder="Bio"
                            label={
                              characterCount
                                ? `Bio (${
                                    characterCount.split("").length
                                  }/500 characters)`
                                : "Bio"
                            }
                            maxLength={500}
                            onChange={(e) => setCharacterCount(e.target.value)}
                          />

                          <div className="fixed bottom-0 w-[87%] bg-white  h-[80px] flex justify-center items-center ml-[-2px]">
                            {isEdit ? (
                              <div className="flex justify-between w-full gap-4">
                                <input
                                  disabled={isSubmitting}
                                  value={
                                    isSubmitting ? "Loading..." : "Save Changes"
                                  }
                                  type="submit"
                                  className="primary_submit"
                                />
                                <input
                                  disabled={true}
                                  value={"Resend speaker invite"}
                                  type="submit"
                                  className="flex items-center cursor-pointer text-[#1C1C1E] text-[15px] font-[500] border h-[42px] justify-center rounded-[10px] my-[5px] mx-auto px-2"
                                />
                              </div>
                            ) : (
                              <input
                                disabled={isSubmitting}
                                value={
                                  isSubmitting
                                    ? "Loading..."
                                    : "Add & Invite speaker"
                                }
                                type="submit"
                                className="primary_submit"
                              />
                            )}
                          </div>
                        </form>
                      </div>
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    </>
  );
}
